import { use_slice_ui } from '@/hooks/store/use_slices';
import { FIELD_PRIMITIVE__base_string } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/FIELD_PRIMITIVE__base_string';
import { G_HOOK__output__field_hovered_set } from '../_base/_hooks/G_HOOK__output__field_hovered_set';
import { G_UI_FIELD__header } from '../_base/G_UI_FIELD__header';
import { G_UI_FIELD_PRIMITIVE__string_dropdown } from './G_UI_FIELD_PRIMITIVE__string_dropdown';
import { G_UI_FIELD_PRIMITIVE__string_list } from './G_UI_FIELD_PRIMITIVE__string_list';

interface PROPS {
  field: FIELD_PRIMITIVE__base_string;
}

export function G_UI_FIELD_PRIMITIVE__string({ field }: PROPS) {
  /*
   * STORE
   */
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   * STATE
   */

  const { onMouseOver, onMouseLeave } = G_HOOK__output__field_hovered_set({ field });

  /*
   * HTML
   */

  /*
   * METHODS
   */
  function is_disabled() {
    return g_general__ui_disabled || field.meta.ui__is_readonly;
  }

  /*
   * HTML
   */

  return (
    <div
      className={`flex flex-col w-full min-w-0
    `}
      {...{ onMouseOver, onMouseLeave }}
    >
      <G_UI_FIELD__header {...{ field }} />

      <div
        className={`w-full bg-component min-w-0 py-2 px-1
        ${is_disabled() ? 'opacity-50 cursor-not-allowed' : ''}
        `}
      >
        {field.meta.grid2d__is_dimension ? <G_UI_FIELD_PRIMITIVE__string_list {...{ field }} /> : <G_UI_FIELD_PRIMITIVE__string_dropdown {...{ field }} />}
      </div>
    </div>
  );
}
